/**
 * @module resettableStores
 *
 * A registry for Zustand stores whose state is NOT owned by any single page and
 * therefore has no component lifecycle to reset it. Such stores register their
 * `reset` here, and the registry is drained on session boundaries (logout) so
 * one user's state never carries into the next session.
 *
 * Page-tied stores must NOT register here. They reset through the lifecycle of
 * the section that owns them, so their state ends when the thing it describes
 * goes away rather than when the session does.
 */
const resets = new Set<() => void>();

/**
 * Register a store's reset. Returns an unregister function.
 */
export const registerResettableStore = (reset: () => void): (() => void) => {
  resets.add(reset);
  return () => {
    resets.delete(reset);
  };
};

/**
 * Reset every registered store. Called on logout.
 */
export const resetResettableStores = (): void => {
  resets.forEach((reset) => reset());
};
